import React from 'react';

import styled from '@emotion/styled';

import TableMoreOptions from '../TableComponent/TableMoreOptions';

interface ExitedListRowCellProps {
  data?: any;
  moreOptionsComponents?: React.ReactNode[];
}

const ExitedListRowCell: React.FC<ExitedListRowCellProps> = ({
  data,
  moreOptionsComponents,
}) => {
  return (
    <Container>
      <FirstRow>
        <FirstRowLeftItems>
          <FirstText> {data?.name}</FirstText>
        </FirstRowLeftItems>
        {moreOptionsComponents && (
          <TableMoreOptions
            moreOptionsComponents={moreOptionsComponents}
            data={data}
          />
        )}
      </FirstRow>
      <SecondRow>{data?.email}</SecondRow>
      <ThirdRow>
        <div>{data?.phoneNumber} </div>
        <VerticalDivider />
        <div>{data?.gender}</div>
      </ThirdRow>
      <DateRow>{data?.startDate}</DateRow>
    </Container>
  );
};

export default ExitedListRowCell;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  margin-bottom: 12px;
  font-size: 14px;
`;

const FirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: flex;
  position: relative;
  /* g */
`;

const FirstRowLeftItems = styled.div`
  gap: 12px;
  align-items: center;
  margin-right: 18px;
  display: grid;
  grid-auto-flow: column;
  overflow: auto;

  /* Hide scroll bar */
  &::-webkit-scrollbar {
    display: none;
  }

  & > * {
    white-space: nowrap;
  }
`;

const FirstText = styled.div`
  display: flex;
`;

const SecondRow = styled.div`
  /* font-size: 14px; */
`;

const ThirdRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const VerticalDivider = styled.div`
  height: 14px;
  width: 1px;
  background-color: ${({ theme }) => theme.palette.borderColor};
`;

const DateRow = styled.div`
  /* border: 1px solid ${({ theme }) => theme.palette.borderColor}; */
`;
